import { ILocation, ILocationState } from "@/Common/interfaces/location";
import { useSelector } from "react-redux";

export function useLocation(): ILocation {
	return useSelector((state: ILocationState) => state.location.location);
}
